module.exports = __webpack_public_path__ + "static/media/pie-icon.64763b10.svg";